import React from 'react'

export default function BracketPlayerNames({ team, className = '', teamSize = 1 }) {
  if (!team) return null

  if (!team.players || team.players.length === 0) {
    return <span className={`text-[15px] italic text-muted-foreground ${className}`}>TBD</span>
  }

  if (teamSize > 1) {
    const playerSlots = []
    for (let i = 0; i < teamSize; i++) {
      if (team.players[i]) {
        playerSlots.push(
          <span key={i} className={`text-[15px] truncate block ${className}`}>
            {team.players[i].name}
          </span>
        )
      } else {
        playerSlots.push(
          <span key={i} className={`text-[15px] truncate block italic text-muted-foreground ${className}`}>
            TBD
          </span>
        )
      }
    }
    return (
      <div className="flex flex-col gap-[3px] min-w-0 overflow-hidden">
        {playerSlots}
      </div>
    )
  }

  return <span className={`text-[15px] truncate block ${className}`}>{team.players[0].name}</span>
}
